import React, { useState, useEffect, memo } from "react";
import "./templateModal.scss";
import { Modal, TextInput, Button } from "@carbon/react";
import { useTranslation } from "react-i18next";
import { useSetTemplate } from "../../hooks/useSetTemplate";
import TemplateItem from "./TemplateItem";

const CreateTemplateModal = memo(
  ({
    createModalVisibility,
    setCreateModalVisibility,
    templatesValues,
    setTemplatesValues,
  }) => {
    const { t } = useTranslation();

    const [templateName, setTemplateName] = useState("");
    const [validation, setValidation] = useState({
      invalid: false,
      invalidText: "",
    });

    const [toBeClosed, setToBeClosed] = useState(false);

    const mutationSetItem = useSetTemplate();
    const mutationSetList = useSetTemplate();

    const onCreateTemplate = () => {
      if (
        templateName.trim() !== "" &&
        !templatesValues.some((item) => item === templateName)
      ) {
        setTemplatesValues((prevValues) => [...prevValues, templateName]);

        mutationSetItem.mutate({
          key: templateName,
          value: localStorage.getItem("storage"),
        });

        setTemplateName("");
      } else if (templateName.trim() === "") {
        setValidation({
          invalid: true,
          invalidText:
            "authentication.validationErrors.noTemplateNameValidation",
        });
      } else if (templatesValues.some((item) => item === templateName)) {
        setValidation({
          invalid: true,
          invalidText: "authentication.validationErrors.templateNameValidation",
        });
      } else {
        setValidation({ invalid: false, invalidText: "" });
      }
    };

    useEffect(() => {
      if (templateName.trim() === "") {
        setValidation({
          invalid: true,
          invalidText:
            "authentication.validationErrors.noTemplateNameValidation",
        });
      }
      if (templatesValues.some((item) => item === templateName)) {
        setValidation({
          invalid: true,
          invalidText: "authentication.validationErrors.templateNameValidation",
        });
      } else {
        setValidation({ invalid: false, invalidText: "" });
      }
    }, [templateName, setValidation]);

    useEffect(() => {
      if (mutationSetItem.isSuccess) {
        mutationSetList.mutate({
          key: "customUserTemplateName",
          value: JSON.stringify(templatesValues),
        });
      }
    }, [mutationSetItem.isSuccess]);

    return (
      <Modal
        open={createModalVisibility}
        aria-label=""
        size="sm"
        passiveModal
        hasScrollingContent={true}
        onRequestClose={() => {
          setCreateModalVisibility(false);
          setToBeClosed((prevValue) => !prevValue);
          setValidation({ invalid: false, invalidText: "" });
        }}
      >
        <div className="create_template">
          <h3>Create custom template</h3>
          <p>
            New template will be created from current table. Take note that
            the layout name must be unique and not be an empty string or contain
            more than 50 characters.
            <br />
            Please be warn that you can have only 5 custom templates.
          </p>
          <div className="create_template_input">
            <TextInput
              data-modal-primary-focus
              invalid={validation.invalid}
              invalidText={
                validation.invalidText ? t(validation.invalidText) : ""
              }
              maxCount={50}
              enableCounter={true}
              id="text-input-create"
              labelText="Template name"
              placeholder="some template"
              value={templateName}
              onChange={(e) => setTemplateName(e.target.value)}
              disabled={templatesValues.length >= 5 ? true : false}
            />
            <Button
              onClick={onCreateTemplate}
              size="md"
              disabled={templatesValues.length >= 5 ? true : false}
            >
              Add
            </Button>
          </div>
        </div>
        <div className="change_template">
          {templatesValues.length > 0 && (
            <div className="change_template_items">
              <h3>Your templates</h3>
              <p>
                You can change the template name or delete it. The rules for
                editing the name are the same as the rules for creating it.<br/>To
                edit the template composition, please select the template you want
                on the toolbar and click the "Edit current template value" button.
              </p>
              {templatesValues.map((item, index) => (
                <TemplateItem
                  key={index}
                  item={item}
                  index={index}
                  templatesValues={templatesValues}
                  setTemplatesValues={setTemplatesValues}
                  toBeClosed={toBeClosed}
                />
              ))}
            </div>
          )}
        </div>
      </Modal>
    );
  }
);

export default CreateTemplateModal;
